/** Panneau d'administration — comptes, stockage, message direct. */
import { el, clear } from '../ui/dom.js';
import { icon } from '../ui/icons.js';
import { api } from '../api.js';
import { toast } from '../ui/toast.js';

function fmtBytes(b) {
  if (!b || b < 1) return '0 o';
  const u = ['o', 'Ko', 'Mo', 'Go', 'To'];
  const i = Math.min(u.length - 1, Math.floor(Math.log(b) / Math.log(1024)));
  const v = b / Math.pow(1024, i);
  return (v >= 10 || i === 0 ? Math.round(v) : v.toFixed(1)) + ' ' + u[i];
}
const avatarEl = (u) => { const a = el('div', { class: 'avatar sm' }); if (u.picture) a.appendChild(el('img', { src: u.picture, alt: '' })); else a.textContent = (u.name[0] || '?').toUpperCase(); return a; };

export function renderAdmin(ctx) {
  const { content, navigate } = ctx;
  ctx.setCrumbs([{ label: 'Administration' }]);
  content.append(el('div', { class: 'hero' }, el('h1', {}, 'Administration'), el('p', {}, 'Tous les comptes, leur stockage, et message direct en un clic.')));
  const wrap = el('div', { class: 'admin-list glass', style: { padding: '8px' } }, el('div', { style: { color: 'var(--text-faint)', padding: '16px' } }, 'Chargement…'));
  content.appendChild(wrap);

  api.get('/api/admin/users').then(({ users, quota }) => {
    clear(wrap);
    wrap.appendChild(el('div', { class: 'admin-row admin-head' }, el('span', {}, `Compte (${users.length})`), el('span', {}, 'Stockage'), el('span', { style: { textAlign: 'right' } }, 'Éléments')));
    users.forEach((u) => {
      const pct = quota ? Math.min(100, (u.used / quota) * 100) : 0;
      const name = el('b', { class: 'admin-name', title: 'Envoyer un message' }, u.name);
      name.addEventListener('click', async () => {
        try {
          const { conversation } = await api.post('/api/chat/conversations', { identifier: u.email || u.nickname });
          sessionStorage.setItem('jhn-open-conv', conversation.id);
          navigate('/messages');
        } catch (e) { toast(e.message, 'err'); }
      });
      wrap.appendChild(el('div', { class: 'admin-row' },
        el('div', { class: 'admin-user' }, avatarEl(u), el('div', { style: { minWidth: 0 } }, name, el('div', { class: 'admin-email' }, u.email || ''))),
        el('div', { class: 'admin-storage' }, el('div', { class: 'bar' }, el('i', { style: { width: pct.toFixed(0) + '%' } })), el('span', {}, `${fmtBytes(u.used)} / ${fmtBytes(quota)}`)),
        el('div', { class: 'admin-items' }, String(u.items))));
    });
    if (!users.length) wrap.appendChild(el('div', { style: { padding: '20px', color: 'var(--text-faint)' } }, 'Aucun compte.'));
  }).catch((e) => {
    clear(wrap);
    wrap.appendChild(el('div', { class: 'empty' }, el('div', { class: 'ico', html: icon('x', 30) }), el('h3', {}, 'Accès refusé'), el('div', {}, e.message)));
  });
}
